<template lang="pug">
.confirm-card
  .card
    ticket-card
  .info
    .dates
      .date {{year}}年{{month}}月{{date}}日
      time-range(:fs1="30" :fs2="90" :schedule="schedulePicked")
    .fam
      //fam-stack
      avatar-stack
      .copy {{avatars.length}}位参观者
    .detail
      .row
        .key 门票类型
        .value {{ticketType}}
      .row
        .key 参观人员
        .value {{users}}
      .row
        .key 金额支付
        .value {{moneyDetail}}
      .row
        .key 积分支付
        .value {{pointDetail}}          
    //.point
      point-deduct
    .total
      .row
        .key 合计
        .value {{total}}
  //- charity-bar(:money="money")
  charity-bar-alipay
  
</template>
<script>
import TicketCard from '@/components/wedgits/TicketCard'
import TimeRange from '@/components/wedgits/TimeRange'
import FamStack from '@/components/wedgits/FamStack'
import PointDeduct from '@/components/res/PointDeduct'
import { mapState, mapGetters } from 'vuex'
import AvatarStack from '@/components/wedgits/AvatarStack'
import CharityBar from '@/components/res/CharityBar'
import CharityBarAlipay from '@/components/res/CharityBarAlipay'
export default {
  name: 'ConfirmCard',
  components: {
    CharityBar,
    AvatarStack,
    PointDeduct,
    FamStack,
    TimeRange,
    TicketCard,
    CharityBarAlipay,
  },
  props: {},
  data() {
    return {
      adultCnt: 0,
      childCnt: 0,
      money: 0,
      point: 0,
    }
  },
  watch: {
    ticketPicked(val) {
      this.genInfo()
    },
  },
  computed: {
    ...mapState('app', ['schedulePicked', 'user', 'ticketPicked']),
    ...mapGetters('app', ['fams']),
    year() {
      return this.schedulePicked.from.getFullYear()
    },
    month() {
      return this.schedulePicked.from.getMonth() + 1
    },
    date() {
      return this.schedulePicked.from.getDate()
    },
    avatars() {
      // return this.fams.map((u) => {
      //   return u.avatar
      // })
      return this.user.famUsers.map((u) => {
        return u.avatar
      })
    },
    ticketType() {
      return this.ticketPicked.title
    },
    users() {
      return this.childCnt > 0
        ? `${this.adultCnt}成人, ${this.childCnt}儿童`
        : `${this.adultCnt}成人`
    },
    moneyDetail() {
      return this.childCnt > 0
        ? `￥${this.ticketPicked.money}X${this.adultCnt}+￥${this.ticketPicked
            .money / 2}X${this.childCnt}`
        : `￥${this.ticketPicked.money}X${this.adultCnt}`
    },
    pointDetail() {
      return this.childCnt > 0
        ? `${this.ticketPicked.point}积分X${this.adultCnt}+${this.ticketPicked
            .point / 2}积分X${this.childCnt}`
        : `${this.ticketPicked.point}积分X${this.adultCnt}`
    },
    total() {
      return this.money > 0
        ? `￥${this.money}+${this.point}积分`
        : `${this.point}积分`
    },
  },
  created() {
    this.genInfo()
  },
  methods: {
    genInfo() {
      this.user.famUsers.map((u) => {
        if (u.userType === 0) {
          this.adultCnt++
        } else {
          this.childCnt++
        }
      })
      console.log(this.childCnt)
      this.money =
        this.ticketPicked.money * this.adultCnt +
        (this.ticketPicked.money * this.childCnt) / 2
      this.point =
        this.ticketPicked.point * this.adultCnt +
        (this.ticketPicked.point * this.childCnt) / 2
    },
  },
  mounted() {
    //this.genInfo()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.confirm-card
  position: relative
  width: 100%
  height: 100%
  .card
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
  .info
    position: relative
    z-index: 10
    width: 100%
    height: 100%
    padding: pxToRem(38) pxToRem(80)
    .dates
      animation: fadeIn 0.7s $easeOutCubic both 0.2s
      .date
        font-size: pxToRem(36)
        font-family: $ff-cn
        line-height: pxToRem(50)
        letter-spacing: pxToRem(0.8)
    .fam
      animation: fadeIn 0.7s $easeOutCubic both 0.4s
      margin-top: pxToRem(90)
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      flex-direction: row
      .copy
        font-size: pxToRem(26)
        color: black
    .detail
      margin-top: pxToRem(50)
      width: 100%
      .row
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(26)
        margin-bottom: pxToRem(15)
        .value
    .total
      animation: fadeIn 0.7s $easeOutCubic both 0.6s
      margin-top: pxToRem(60)
      .row
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(32)
        .value
          color: $cl-orange
@keyframes fadeIn
  0%
    opacity: 0
    transform: translateY(20%)
  100%
    opacity: 1
    transform: translateY(0)
</style>
